import once from 'lodash/once';
import { createContext } from 'react';
/** Represents the create item context. */
export const getCreateItemContext = once(() => createContext(undefined));
